<template>
  <div class="supportMain">
    <div class="supportMain--col"
    v-for="(itemSobre, index) in sobre" :key="index.sobre">
      <router-link
      to="/sobre"
      title='Sobre'
      class="navMain--itemLink">
        <ThumbsMain
        title=' '
        :text='itemSobre.title'
        :img='itemSobre.imgSmall'/>
      </router-link>
    </div>

    <div class="supportMain--col supportMain--col2"
    v-for="(itemAmartya, index) in amartya" :key="index.amartya">
      <router-link
      to="/amartyasen"
      title='Amartya Sen'
      class="navMain--itemLink">
        <ThumbsMain
        title=' '
        :text='itemAmartya.title'
        :img='itemAmartya.imgSmall'/>
      </router-link>
    </div>

    <div class="supportMain--col"
    v-for="(itemEquipe, index) in equipe" :key="index.equipe">
      <router-link
      to="/equipe"
      title='Equipe'
      class="navMain--itemLink">
        <ThumbsMain
        title=' '
        :text='itemEquipe.title'
        :img='itemEquipe.imgSmall'/>
      </router-link>
    </div>
  </div>
</template>

<script>
import { apis } from '@/api.js'
import ThumbsMain from '@/components/_ThumbsMain'

export default {
  name: 'SupportMain',
  components: {
    ThumbsMain
  },
  data () {
    return {
      urlSobre: apis.api.sobreAPI,
      sobre: '',
      urlAmartya: apis.api.amartyaAPI,
      amartya: '',
      urlEquipe: apis.api.equipecapaAPI,
      equipe: ''
    }
  },
  methods: {
    getApiSobre () {
      fetch(this.urlSobre)
        .then(response => response.json())
        .then(response => {
          this.sobre = response
        })
    },
    getApiAmartya () {
      fetch(this.urlAmartya)
        .then(response => response.json())
        .then(response => {
          this.amartya = response
        })
    },
    getApiEquipe () {
      fetch(this.urlEquipe)
        .then(response => response.json())
        .then(response => {
          this.equipe = response
        })
    }
  },
  created () {
    this.getApiSobre()
    this.getApiAmartya()
    this.getApiEquipe()
  }
}
</script>

<style>

</style>
